"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
var labels = {
  login: 'Login',
  logout: 'Logout',
  none: 'None',
  undefined: 'Undefined',
  product_categories: 'Product Categories',
  all_categories: 'All Categories',
  sort: 'Sort',
  select: 'Select',
  keyword: 'Keyword',
  list: 'List',
  order: 'Order',
  order_id: 'Order ID',
  order_created: 'Order Created',
  order_content: 'Order Content',
  pieces_of_item: 'Pieces of item',
  cart_items: 'Cart Items',
  item: 'Item',
  spec: 'Specification',
  total: 'Total',
  subtotal: 'Subtotal',
  price_info: 'Price information',
  product: 'Product',
  fee: 'Fee',
  discount: 'Discount',
  order_title: '我的訂單en',
  order_info: 'Order information',
  order_status: 'Order status',
  order_note: 'Order note',
  order_total: 'Order total',
  order_quantity: 'Quantity',
  payment_type: 'Payment type',
  payment_status: 'Payment status',
  buyer_info: 'Buyer information',
  buyer_name: 'Buyer name',
  buyer_phone: 'Buyer phone',
  buyer_email: 'Buyer email',
  buyer_address: 'Buyer address',
  buyer_tel: 'Buyer telephone',
  buyer_tel_ext: 'Buyer telephone extension number',
  receiver_info: '收件人資訊en',
  receiver_name: '收件人姓名en',
  receiver_phone: '收件人電話en',
  receiver_email: '收件人信箱en',
  receiver_address: '收件人地址en',
  receiver_tel: '市話en',
  invoice_info: '發票資訊en',
  payment_logistics_section_title: '付款及運送方式en',
  cart_empty_title: '您的購物車為空en',
  shopping: '立刻購物去en',
  back_products: '返回全部商品en',
  return: '退貨en',
  check_return_status: '查看退貨狀態en',
  apply_return: '申請退貨en',
  return_form: '退貨表單en',
  return_reason: '退貨理由en',
  return_status: '退貨狀態en',
  edit_return_info_forbidden: '未開放修改退貨資訊en',
  edit_return_info: '修改退貨資訊en',
  return_response_title: '商家回覆en',
  other_login_way: 'or login with other methods',
  login_error: 'Login failed, please try again',
  account: 'Account',
  password: 'Password',
  register_now: 'Register Now',
  no_account: "Don't have an account",
  forgot_password: 'Forgot Password',
  reset: 'Reset',
  enter_account: 'Please enter account',
  enter_password: 'Please enter password',
  all: 'All',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday'
};
exports.labels = labels;